import { Navigate, Outlet } from "react-router-dom";

function IsLogin(){

    const token = localStorage.getItem("token");

    return(token ? <Outlet /> : <Navigate to="/" />)
}


export default IsLogin;